module.exports = __webpack_public_path__ + "media/images/common/menu_btn6-ff78837212745a556677df0d8689bf5e.png";